// redux/refreshSlice.js
import { createSlice } from "@reduxjs/toolkit";

const refreshSlice = createSlice({
  name: "refresh",
  initialState: {
    key: 0, // 👈 Key to trigger re-render
  },
  reducers: {
    triggerRefresh: (state) => {
      state.key += 1; // 👈 Increment key to force refresh
    },
  },
});

export const { triggerRefresh } = refreshSlice.actions;
export default refreshSlice.reducer;